import type { MarketplaceId } from "@nova-ai/shared"

import { humanizeMarketplaceId } from "../../lib/marketplace"
import { MarketplaceLogo } from "../marketplaces/marketplace-logo"
import { Combobox, type ComboboxOption } from "../ui/combobox"

type ProductMarketplaceSelectProps = {
  id?: string
  marketplaces: MarketplaceId[]
  value: MarketplaceId | undefined
  isLoading: boolean
  isError: boolean
  onChange: (marketplace: MarketplaceId | undefined) => void
}

export function ProductMarketplaceSelect({
  id,
  marketplaces,
  value,
  isLoading,
  isError,
  onChange,
}: ProductMarketplaceSelectProps) {
  const options: ComboboxOption[] = marketplaces.map((marketplace) => ({
    value: marketplace,
    label: humanizeMarketplaceId(marketplace),
    icon: <MarketplaceLogo marketplace={marketplace} />,
  }))

  return (
    <Combobox
      aria-label="Marketplace"
      id={id}
      options={options}
      value={value}
      disabled={isLoading || isError}
      title={isError ? "Configured marketplaces could not be loaded" : undefined}
      placeholder="All marketplaces"
      clearLabel="All marketplaces"
      searchPlaceholder="Search marketplaces…"
      emptyMessage="No marketplaces"
      onChange={(nextValue) => {
        const marketplace = marketplaces.find((candidate) => candidate === nextValue)
        onChange(marketplace)
      }}
      className="w-full sm:w-48"
    />
  )
}
